import { create } from '@bufbuild/protobuf'

import {
  DateSchema,
  Date as GoogleDate,
} from '@enechain/eposition-proto/google/type/date_pb'

export function convertGoogleDateModel(date: Date): GoogleDate {
  return create(DateSchema, {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
  })
}

export function convertDateFromGoogleDate(date: GoogleDate): Date {
  return new Date(date.year, date.month - 1, date.day)
}

export function formatGoogleDate(
  date: Pick<GoogleDate, 'year' | 'month' | 'day'>,
  delimiter?: '/' | '-',
): string {
  if (delimiter === undefined) {
    return `${date.year}${date.month}${date.day}`
  }
  return `${date.year}${delimiter}${date.month}${delimiter}${date.day}`
}
